import * as React from "react";
function SvgArrowsCrossing(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M27 11l4-4-4-4M27 29l4-4-4-4"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M1 7h5l18 18h6"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M1 25h5L24 7h6"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsCrossing);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
